var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "wrap wrap--sub"
  }, [_c('sub-visual', {
    attrs: {
      "visual": '마이페이지'
    }
  }), _c('mypage-navigation'), _c('section', {
    staticClass: "section--sm section--first"
  }, [_c('v-container', [_c('tit-primary', {
    attrs: {
      "sc": "Attendance status",
      "tit": "출석 현황"
    }
  }), _c('service-program-card', _vm._b({
    attrs: {
      "hideApplyButton": ""
    }
  }, 'service-program-card', {
    program: _vm.program
  }, false))], 1)], 1), _c('section', {
    staticClass: "section--sm section--last"
  }, [_c('v-container', [_c('h4', {
    staticClass: "tit--sm mb-16 mb-lg-34"
  }, [_vm._v("행사일정")]), _c('service-program-attendances', _vm._b({}, 'service-program-attendances', {
    program: _vm.program
  }, false)), _c('div', {
    staticClass: "board-buttons d-flex justify-end mt-20 mt-lg-30"
  }, [_c('v-btn', {
    staticClass: "h-lg-40px",
    attrs: {
      "small": "",
      "outlined": "",
      "color": "grey"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.go(-1);
      }
    }
  }, [_c('span', {
    staticClass: "color-grey"
  }, [_vm._v("List")])])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }